export default __webpack_public_path__ + "static/media/Introduction.d4a6ce31.png";